/** ISO 3166-1 alpha-2 codes with flag emoji (regional indicator pairs). */

function flagFromCode(code) {
  return [...code.toUpperCase()]
    .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
    .join('');
}

const COUNTRY_NAMES = {
  AR: 'Argentina',
  AT: 'Austria',
  AU: 'Australia',
  BE: 'Belgium',
  BR: 'Brazil',
  CA: 'Canada',
  CH: 'Switzerland',
  CL: 'Chile',
  CN: 'China',
  CO: 'Colombia',
  CZ: 'Czechia',
  DE: 'Germany',
  DK: 'Denmark',
  EG: 'Egypt',
  ES: 'Spain',
  FI: 'Finland',
  FR: 'France',
  GB: 'United Kingdom',
  GR: 'Greece',
  HU: 'Hungary',
  ID: 'Indonesia',
  IE: 'Ireland',
  IL: 'Israel',
  IN: 'India',
  IR: 'Iran',
  IS: 'Iceland',
  IT: 'Italy',
  JP: 'Japan',
  KR: 'South Korea',
  MX: 'Mexico',
  NL: 'Netherlands',
  NO: 'Norway',
  NZ: 'New Zealand',
  PE: 'Peru',
  PH: 'Philippines',
  PL: 'Poland',
  PT: 'Portugal',
  RO: 'Romania',
  RU: 'Russia',
  SE: 'Sweden',
  SG: 'Singapore',
  TR: 'Türkiye',
  UA: 'Ukraine',
  US: 'United States',
  UY: 'Uruguay',
  VN: 'Vietnam',
  ZA: 'South Africa',
  XX: 'Intergalactic'
};

export const COUNTRIES = Object.entries(COUNTRY_NAMES)
  .map(([code, name]) => ({
    code,
    name,
    flag: code === 'XX' ? '🌐' : flagFromCode(code)
  }))
  .sort((left, right) => left.name.localeCompare(right.name));

const BY_CODE = Object.fromEntries(COUNTRIES.map((country) => [country.code, country]));

export function normalizeCountryCode(value) {
  const code = String(value || '').trim().toUpperCase();
  return BY_CODE[code] ? code : '';
}

export function countryFlag(code) {
  const normalized = normalizeCountryCode(code);
  return normalized ? BY_CODE[normalized].flag : '🏳️';
}

export function countryLabel(code) {
  const normalized = normalizeCountryCode(code);
  if (!normalized) {
    return 'Unset';
  }
  const country = BY_CODE[normalized];
  return `${country.flag} ${country.name}`;
}

export function pieceFlairForPlayerId(playerId) {
  const pieces = ['♙', '♞', '♝', '♜', '♛', '♚', '♟', '♘'];
  const hex = String(playerId || '').replace(/[^0-9a-f]/gi, '');
  const index = Number.parseInt(hex.slice(-2) || '0', 16) % pieces.length;
  return pieces[index];
}
